import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import styles from './NotFoundPage.module.css';

const NotFoundPage = () => {
  useEffect(() => {
    document.title = '404 - Refracted | Prism LIMS';
  }, []);

  return (
    <div className={styles['not-found-page']}>
      <div className={styles['not-found-content']}>
        <div className={styles['prism-logo']}>
          <img 
            src="/PrismVial_Small.jpg.png" 
            alt="Prism Vial" 
            className={styles['not-found-logo']}
          />
        </div>
        
        <div className={styles['error-code']}>
          <span className={styles.four}>4</span>
          <span className={`${styles.zero} ${styles['prismatic-zero']}`}>0</span>
          <span className={styles.four}>4</span>
        </div>
        
        <h1 className={styles['error-title']}>
          Light <span className={styles.refracted}>Refracted</span>
        </h1>
        
        <p className={styles['error-message']}>
          This wavelength couldn't be found in our spectrum.
        </p>
        
        <div className={styles['action-buttons']}>
          <Link to="/" className={styles['home-button']}>
            Return to Home.
          </Link>
        </div>
        
      </div>
      
      {/* Animated light particles */}
      <div className={styles['light-particles']}>
        <div className={`${styles.particle} ${styles['particle-1']}`}></div>
        <div className={`${styles.particle} ${styles['particle-2']}`}></div>
        <div className={`${styles.particle} ${styles['particle-3']}`}></div>
        <div className={`${styles.particle} ${styles['particle-4']}`}></div>
        <div className={`${styles.particle} ${styles['particle-5']}`}></div>
      </div>
    </div>
  );
};

export default NotFoundPage;
